import React from 'react';
import { motion } from 'framer-motion';

export default function FriendlyRobot({ size = 200 }) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      animate={{ rotate: [0, 4, -4, 0], y: [0, -3, 0] }}
      transition={{ rotate: { duration: 4, repeat: Infinity, ease: 'easeInOut' }, y: { duration: 5, repeat: Infinity, ease: 'easeInOut' } }}
      style={{ originX: '50%', originY: '50%' }}
    >
      <defs>
        <linearGradient id="screenGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#2dd4bf" />
          <stop offset="100%" stopColor="#0891b2" />
        </linearGradient>
        <filter id="neon" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      {/* Screen head */}
      <rect
        x="10" y="10" width="80" height="80" rx="15"
        fill="url(#screenGrad)"
        stroke="#06b6d4" strokeWidth="2"
        filter="url(#neon)"
      />
      {/* Sensors */}
      <circle cx="20" cy="20" r="3" fill="#06b6d4" filter="url(#neon)" />
      <circle cx="80" cy="20" r="3" fill="#06b6d4" filter="url(#neon)" />
      {/* Digital eyes */}
      <motion.circle
        cx="35" cy="45" r="6" fill="#000"
        initial={{ scaleY: 1 }}
        animate={{ scaleY: [1, 0.1, 1] }}
        transition={{ duration: 0.15, repeat: Infinity, repeatDelay: 2.5, ease: 'linear' }}
        style={{ originX: '35px', originY: '45px' }}
      />
      <motion.circle
        cx="65" cy="45" r="6" fill="#000"
        initial={{ scaleY: 1 }}
        animate={{ scaleY: [1, 0.1, 1] }}
        transition={{ duration: 0.15, repeat: Infinity, repeatDelay: 3, ease: 'linear' }}
        style={{ originX: '65px', originY: '45px' }}
      />
      {/* Mouth line */}
      <line
        x1="35" y1="70" x2="65" y2="70"
        stroke="#000" strokeWidth="3" strokeLinecap="round"
      />
    </motion.svg>
  );
}
